import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { showUpcomingLiveClassesBottomSheetAction } from "@src/components/BottomSheets/store/actions";
import { useDispatch } from "react-redux";
import { getCourseDetailsAction } from "../../store/actions";
import { useRouter } from "@src/lib/router";
import {
  getLiveCardDeepLink,
  getLiveCardIsAgora,
  getNewLiveCardStackType,
  LIVE_STACKTYPES,
} from "@src/utils/liveService/util";
import { selectNewLiveService } from "@root/store/selectors";

import Slider from "react-slick";
import LiveClassCard from "./LiveClassCard";
import TabSectionCard from "@src/components/TabSectionCard";

function UpcomingLive({
  heading,
  headingColor,
  viewAllText,
  viewAllTextColor,
  subText,
  subTextColor,
  dotClasses,
  backgroundColor,
  zIndex
}) {
  // ROUTER
  const router = useRouter();
  // DISPATCH
  const dispatch = useDispatch();

  const toggleModal = () => {
    dispatch(showUpcomingLiveClassesBottomSheetAction(true));
  };
  // SELECTORS
  const list = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.upcomingLiveClasses?.data
  );
  const upcomingData = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.upcomingLiveClasses
  );

  const useNewLiveService = useSelector(selectNewLiveService);

  useEffect(() => {
    window.onLiveClassEnd = () => {
      // alert("onLiveClassEnd");
      dispatch(
        getCourseDetailsAction({
          courseId: router?.query?.courseId,
          isLoading: false,
        })
      );
    };
  });

  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dotsClass: dotClasses || "UpcomingLive__Body__Dots slick-dots",
    touchThreshold: 10,
  };

  return (
    <div>
      {list?.length ? (
        <TabSectionCard
          mainHeading={heading}
          mainHeadingColor={headingColor}
          viewAllText={list?.length > 1 ? viewAllText : null}
          viewAllTextColor={viewAllTextColor}
          backgroundColor={backgroundColor}
          subText={upcomingData?.subHeading || ""}
          subTextColor={subTextColor}
          btnClickHandler={toggleModal}
          className="UpcomingLive"
          zIndex={zIndex}
        >
          <div className="UpcomingLive__Body blockSlide">
            <Slider {...settings}>
              {list?.slice(0, 5)?.map((item, i) => (
                <div key={i}>
                  <LiveClassCard
                    title={item?.title}
                    time={item?.scheduleTime}
                    emblem4={item?.emblem4}
                    scheduleTime={item?.scheduleTime}
                    index={i}
                    liveEmblem={item?.emblem1}
                    scheduleEmblem={item?.emblem2}
                    trialEmblem={item?.emblem3}
                    deeplink={getLiveCardDeepLink(item?.liveCard)}
                    isAgora={
                      !useNewLiveService
                        ? getLiveCardIsAgora(item?.liveCard) ==
                          LIVE_STACKTYPES.AGORA
                        : getNewLiveCardStackType(item?.liveCard) === "agora"
                    }
                    socialLinks={item?.socialLinks}
                    isLiveClassShareable={item?.isLiveClassShareable}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </TabSectionCard>
      ) : null}
    </div>
  );
}

const MemoizedUpcomingLive = React.memo(UpcomingLive);

export default MemoizedUpcomingLive;
